// Handle generic AJAX Load More

const setupPagination = () => {
  let $paginatedList = $('[data-paginated-list]')
  const $paginatedTrigger = $('[data-paginated-list-trigger]')

  if (!$paginatedList.length || !$paginatedTrigger.length) {
    return
  }

  $('body').on('click', '[data-paginated-list-trigger]', (e) => {
    e.preventDefault()

    const $trigger = $(e.currentTarget)
    const $paginatedListNav = $trigger.closest('[data-paginated-list-nav]')
    const $leftList = $paginatedList.filter('[data-paginated-list="left"]')
    const $rightList = $paginatedList.filter('[data-paginated-list="right"]')
    const hasColumns = ($leftList.length || $rightList.length)

    if ($paginatedListNav.siblings('[data-paginated-list]').length) {
      $paginatedList = $paginatedListNav.siblings('[data-paginated-list]').first()
    }

    let url = $trigger.prop('href')

    if ($trigger.data('type')) {
      url += `&type=${$trigger.data('type')}`
    }

    $.ajax({
      type: 'get',
      dataType: 'json',
      url: url,
      beforeSend: () => {
        $trigger.addClass('disabled')
      },
      success: (resp) => {
        if (resp.success) {
          if (hasColumns) {
            if ($trigger.is('[data-paginated-list-hide]')) {
              $leftList.html(resp.data.list_left)
              $rightList.html(resp.data.list_right)
            } else {
              $leftList.append(resp.data.list_left)
              $rightList.append(resp.data.list_right)
            }
          } else {
            if ($trigger.is('[data-paginated-list-hide]')) {
              $paginatedList.html(null).append(resp.data.list)
            }
            else {
              $paginatedList.append(resp.data.list)
            }
          }

          $paginatedListNav.replaceWith(resp.data.nav)
        }
      },
      complete: () => {
        $trigger.removeClass('disabled')
      }
    })
  })
}

$(document).ready(function () {
  setupPagination()
})
